import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const MonetizationEnabledRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(true);

  useEffect(() => {
    const checkMonetization = async () => {
      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          setAllowed(false);
          setLoading(false);
          return;
        }
        const headers = {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        };
        const res = await axios.get(
          `${process.env.REACT_APP_Baseurl}/advertiser/ads-monetization-status`,
          { headers }
        );
        const adsPaymentStatus = Number(res?.data?.data?.ads_payment_status ?? res?.data?.data?.status ?? 0);
        // If monetization disabled (0), route not allowed
        const canAccess = adsPaymentStatus === 1;
        setAllowed(canAccess);
        if (!canAccess) {
          toast.info('Plans are disabled because ads monetization is not active.');
        }
      } catch (err) {
        // On error, be conservative and block
        setAllowed(false);
      } finally {
        setLoading(false);
      }
    };
    checkMonetization();
  }, []);

  if (loading) return null; // or a tiny loader if desired
  if (!allowed) return <Navigate to="/ads-list" replace />;
  return children;
};

export default MonetizationEnabledRoute;
